import type { ScriptReviewStatus } from "@/features/script-review/api/script-review.api";

type TranslateFn = (key: string, defaultValue: string) => string;

const STATUS_LABEL_KEYS: Record<ScriptReviewStatus, string> = {
  QUEUED: "scriptReview.status.QUEUED",
  ANALYZING: "scriptReview.status.ANALYZING",
  COMPLETED: "scriptReview.status.COMPLETED",
  FAILED: "scriptReview.status.FAILED",
};

const STATUS_LABEL_DEFAULTS: Record<ScriptReviewStatus, string> = {
  QUEUED: "Queued",
  ANALYZING: "Analyzing…",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

export function translateScriptReviewStatusLabel(t: TranslateFn, status: string): string {
  if (status in STATUS_LABEL_KEYS) {
    const key = status as ScriptReviewStatus;
    return t(STATUS_LABEL_KEYS[key], STATUS_LABEL_DEFAULTS[key]);
  }
  return status;
}

const COMMENT_TYPE_LABEL_KEYS: Record<string, string> = {
  VOICEOVER: "scriptReview.player.categories.voiceover",
  TEXT_OVERLAY: "scriptReview.player.categories.textOverlay",
  VISUAL: "scriptReview.player.categories.visual",
};

const COMMENT_TYPE_LABEL_DEFAULTS: Record<string, string> = {
  VOICEOVER: "Voiceover",
  TEXT_OVERLAY: "On-screen text",
  VISUAL: "Visual",
};

export function translateScriptReviewCommentType(t: TranslateFn, commentType: string): string {
  const key = COMMENT_TYPE_LABEL_KEYS[commentType];
  if (key) {
    return t(key, COMMENT_TYPE_LABEL_DEFAULTS[commentType] ?? commentType);
  }
  return t("scriptReview.player.categories.fallback", "Comment");
}

const FAILED_PASS_TO_TYPE: Record<string, string> = {
  voiceover: "VOICEOVER",
  "text-overlay": "TEXT_OVERLAY",
  visual: "VISUAL",
};

export function translateScriptReviewFailedPass(t: TranslateFn, step: string): string {
  const commentType = FAILED_PASS_TO_TYPE[step];
  if (!commentType) return step;
  return translateScriptReviewCommentType(t, commentType);
}
